import { useState } from "react";
import SalesReport from "./SalesReport";
import ProfitReport from "./ProfitReport";
import InventoryReport from "./InventoryReport";
import TaxReport from "./TaxReport";
import "./Reports.css";

export default function Reports() {
  const [activeTab, setActiveTab] = useState("sales");

  const tabs = [
    { id: "sales", label: "Sales", icon: "📊" },
    { id: "tax", label: "Sales Tax", icon: "🧾" },
    { id: "profit", label: "Profit", icon: "💰" },
    { id: "inventory", label: "Inventory", icon: "📦" },
  ];

  return (
    <div className="reports-container">
      <div className="tabs-header">
        <h1 className="page-title">📈 Reports</h1>
        <div className="tabs-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="tabs-content">
        {activeTab === "sales" && <SalesReport />}
        {activeTab === "tax" && <TaxReport />}
        {activeTab === "profit" && <ProfitReport />}
        {activeTab === "inventory" && <InventoryReport />}
      </div>
    </div>
  );
}